<template>
	<div class="modal-card card">
		<form @submit.prevent="onAddHandler()">
			<div class="card-header">
				<!-- Title -->
				<h4 class="card-header-title">Add Handler</h4>
				<!-- Close -->
				<button
					type="button"
					class="btn-close"
					data-bs-dismiss="modal"
					aria-label="Close"
				></button>
			</div>
			<div class="card-body overflow-visible height-100">
				<form-fields :fields="fields" v-model="handler" />
			<JobTemplateSelection  
				v-on:setCurrentTemplate="setCurrentTemplate" 
				v-on:onParameterChanged="onParameterChanged"
				v-on:onSelectTemplate="onSelectTemplate"
				:jobTemplates="jobTemplates" 
				:parameterValue="parameterValue"></JobTemplateSelection>
	
			<div v-if="parametersLoading" class="d-flex align-items-center justify-content-center py-3">
				<div class="spinner-border spinner-border-sm text-primary me-2" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
				<span class="text-muted">Fetching template parameters...</span>
			</div>
				<div v-if="error" class="text-danger">
					{{ error }}
				</div>
			</div>
			<div class="card-footer">
				<div class="text-end">
					<submit-button
						:fields="fields"
						v-model="handler"
						:loading="loading"
					/>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	//handlerFields
	import formFields from "../FormFields.vue";
	import submitButton from "../SubmitButton.vue";
	import { mapActions, mapState } from "vuex";
	import getSandboxJobFields from "../../utils/field-constants/sandboxJobFields";
	import JobTemplateSelection from '../JobTemplateSelection.vue'
	import macros from '../../utils/macros';
	export default {
		components: { formFields, submitButton ,JobTemplateSelection},
		data() {
			return {
				error: "",
				handler: {},
				fields: [],
				loading: false,
				templateName:null,
				currentTemplate: null,
				parameterValue: [],
				parametersLoading: false
			};
		},
		name: "AddHandler",
		created() {
			this.fields = getSandboxJobFields();
			this.initMethod();
		},
		computed: {
			...mapState({
				jobKinds: (state) => state.amdp.jobKinds,
			}),
			jobTemplates() {
				if(this.handler.kind) {
					return this.$store.state.admin.jobTemplates.filter((template) => {
						return template.type == this.handler.kind.toLowerCase()

					});
				}
				return [];
				
			},
		},		
		props: {
			modalData: {
				type: [Object, Array, String],
				default: "",
			},
		},
		methods: {
			...mapActions({
				createSandboxJob: "sandbox/createSandboxJob",
				fetchJobKinds: "amdp/fetchJobKinds",
				updateParameters: "amdp/updateLakeviewParameters"
			}),
			setCurrentTemplate(val) {
				this.currentTemplate = val;
			},
			onParameterChanged(fields) {
				this.parameterValue = fields;
			},
			onSelectTemplate(val) {
				this.parametersLoading = val;
			},
			async onAddHandler() {
				this.loading = true;
				let self =this;
				if (!this.currentTemplate) {
					let system_files = [];
					let jobKindDetailsArr = this.jobKinds?.filter(
						(jobKind) =>
							jobKind.name == this.handler.kind?.toLowerCase()
					);
					let requiredFiles = jobKindDetailsArr[0]?.required_files;
					requiredFiles.map((file) => {
						system_files.push({
							content: " ",
							relative_path: file,
						});
					});
					this.handler.system_files = system_files;
					this.handler.user_files = [
						{ content: "", relative_path: "handler.go" },
					];
				}else{
					this.handler.system_files = this.currentTemplate.system_files;
					this.handler.user_files = this.currentTemplate.user_files;
				}
				this.createSandboxJob(this.handler).then(()=>{
                    if(Object.entries(self.parameterValue).length >0){
						let param =Object.entries(self.parameterValue).map(([key, value])=>{
							return {name: key, value:value}
						})
                        self.updateParameters({
                            sandboxName: `${self.$route.params.sandboxId}`,
                            jobName: self.handler.name, // Fixed: was using self.job.name instead of self.handler.name
                            payload: {
                                parameters: param
                            }
                        }).then(()=>{
                            self.onFinish();
                        }).catch((error) => {
							self.loading = false;
							if (error.response?.data?.error) {
								self.error = error.response.data.error;
							} else {
								self.error = error.message || "Failed to update parameters";
							}
						});
                    }else{
                        self.onFinish();
                    }   
                }).catch((error) => {
					self.loading = false;
					if (error.response?.data?.error) {
						self.error = error.response.data.error;
					} else {
						self.error = error.message || "Failed to create job";
					}
				});
			},			
			
			initMethod() {
				let self = this;
				const currentSandboxObj =
					this.$store.state.sandbox.sandboxes.filter(
						(sandbox) =>
							sandbox.name ===
							self.$store.state.sandbox.currentSandbox
					);				

				this.fields = this.fields.map((field) => {
					if (field.name == "kind") {						
							field.options = [
								{
									label: "AIO-HANDLER-DBDS",
									value: "AIO-HANDLER-DBDS",
								},
								{
									label: "AIO-HANDLER-GRAPHDS",
									value: "AIO-HANDLER-GRAPHDS",
								},
							];
						
					}
					return field;
				});
			},
			async onFinish(){
				this.loading = false;
				this.$store.dispatch("hideModal");
				this.$router.push({
					name: "aIO Handler Configuration",
					params: {
						sandboxId: `${this.$store.state.sandbox.currentSandbox}`,
						jobId: `${this.handler.name}`,
					},
				});
			}
		},		
		beforeMount() {
			this.$store.dispatch("amdp/fetchTemplateJobs");
			if (!this.jobKinds.length) {
				this.fetchJobKinds();
			}
			
		},
	};
</script>

<style></style>
